import type { TENANTSINTERFACE, TENANT_MODEL, TenantById, TENANTBYIDSTORE } from '@fitness-force/models';


export const TENANT_STATE: TENANTSINTERFACE = {
    accessed_tenant: [],
    all_tenant: [],
    selected_tenant: {
        id: 0,
        company_id: 0,
        created_by: 0,
        created_date: '',
        updated_by: 0,
        updated_date: '',
        status: '',
        name_primary_language: '',
        name_secondary_language: '',
        phone1: '',
        email_id: '',
        website: '',
        zone: '',
        place_id: '',
        latitude: 0,
        longitude: 0,
        city: '',
        state: '',
        zip_code: '',
        ip_setting: '',
        live_members: 0,
        image: '',
        exclude_from_app: false
    } as TENANT_MODEL
}

export const TENANT_BY_ID_STATE: TENANTBYIDSTORE = {
    tenant : {
        id: 0,
        company_id: 0,
        name_primary_language: '',
        name_secondary_language: '',
        phone1_country_code: '',
        phone1: '',
        email_id: '',
        website: '',
        zone: '',
        place_id: '',
        latitude: 0,
        longitude: 0,
        city: '',
        state: '',
        zip_code: '',
        ip_setting: '',
        live_members: 0,
        image: '',
        exclude_from_app: true,
        primary_language: '',
        secondary_language: '',
        billing_name: '',
        phone2_country_code: '',
        phone2: '',
        address: '',
        country: '',
        timezone: '',
        timezone_value: '',
        tax_number: '',
        cin_ebn: '',
        ff_subscription_id: '',
        facebook_url: '',
        twitter_url: '',
        instagram_url: '',
        status: ''
    } as TenantById
}
